export const OPTIMIZE_OPTION_WIDTH = 340;
export const OPTIMIZE_OPTION_PADDING = 48;
export const PAGE_INDEX = 1;
